import { ExportDataIcon } from "../../../images";
import { CustomButton } from "../../CustomButton";
import { AccountPlanModal } from "../../modal";
import { useState } from "react";
import { openLinkHandler } from "../../../../utils/openLinkHandler";
import { toast } from "react-toastify";
import { CustomToast } from "../../CustomToast";
import { getErrorMessage } from "../../../../utils/getErrorMessage";
import { useExportAccountPlansMutation } from "../../../../api";
import { AccountPlanStatus } from "../../../../types/enums";
import { CircularProgress } from "@mui/material";

export const ExportAccountsPlanPDFBtn = ({
  account_id,
  campaign_id,
  hideButton = true,
  onClose,
  isSingleAccount,
  btnHeight = "42px",
  btnPadding = "8px",
}: {
  account_id?: string;
  campaign_id: string;
  hideButton?: boolean;
  onClose?: () => void;
  isSingleAccount?: boolean;
  btnHeight?: string;
  btnPadding?: string;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(hideButton);

  const [exportAccountPlans, { isLoading }] = useExportAccountPlansMutation();

  const handleClose = () => {
    setIsOpen(false);
    onClose && onClose();
  };

  const submitHandler = (account_ids: string[], include_all: boolean) => {
    exportAccountPlans({
      campaign_id,
      account_ids,
      include_all,
    })
      .unwrap()
      .then((data) => {
        openLinkHandler(data.url, "Account Plans");
        handleClose();
      })
      .catch((err) => {
        toast.error(
          <CustomToast
            type={"error"}
            text={
              getErrorMessage(err).globalError ||
              "Something went wrong. Please try again"
            }
            title={"Something went wrong"}
          />,
        );
      });
  };

  const onClickHandler = () => {
    if (isSingleAccount && account_id) {
      submitHandler([account_id], false);
    } else {
      setIsOpen(true);
    }
  };

  return (
    <>
      {!hideButton && (
        <CustomButton
          onClick={onClickHandler}
          variant="outlined"
          customColor="#FFFFFF"
          textColor="#1D3E70"
          type="button"
          customSize="fit"
          style={{ padding: btnPadding }}
          sx={{
            borderColor: "#1D3E70",
            minWidth: "fit-content",
            height: btnHeight,
          }}
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress size={24} sx={{ color: "#1C3C6C" }} />
          ) : (
            <ExportDataIcon />
          )}
        </CustomButton>
      )}

      {isOpen && (
        <AccountPlanModal
          title={"Export Account Plans (PDF)"}
          description={
            "Which accounts would you like to create Account Plans for?"
          }
          submitBtnText={"Export Account Plans"}
          status_filter={AccountPlanStatus.completed}
          onClose={handleClose}
          isLoading={isLoading}
          onSubmit={submitHandler}
        />
      )}
    </>
  );
};
